export default __webpack_public_path__ + "static/media/app_example_2.41721a1d.png";